import React from "react";
import Svg from './../Svg';
import guid from "../../helpers/guid";

export default class TextPath extends Svg {
    constructor(id) {
        super();
        this.textContent = '';
        this.tColor = '';
        this.tFontSize = 20;
        this.id = id;
        this.x = 0;
        this.y = 0;
    }

    text(textContent) {
        this.textContent = textContent;
        return this;
    }

    textColor(textColor) {
        this.tColor = textColor;
        return this;
    }

    offset(offset) {
        this.x = offset;
        return this;
    }

    yOffset(offset) {
        this.y = offset;
        return this;
    }

    fontSize(fontSize) {
        this.tFontSize = fontSize;
        return this;
    }

    static create(id) {
        return new TextPath(id);
    }

    draw() {
        this.shape = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        this.shape.setAttribute('fill', this.tColor);
        this.shape.setAttribute('font-size', this.tFontSize);
        this.shape.setAttribute('font-family', 'sans-serif');
        this.shape.setAttribute('text-anchor', 'start');
        this.shape.setAttribute('x', this.x);
        this.shape.setAttribute('y', this.y);

        // this.shape.setAttribute('writing-mode', 'rl-tb');

        const textPath = document.createElementNS('http://www.w3.org/2000/svg', 'textPath');

        textPath.setAttribute('href', `#${this.id}`);
        textPath.textContent = this.textContent;
        this.shape.append(textPath);
        return this.shape;
    }

    element() {
        return (
            <text
                fill={ this.tColor }
                fontSize={ this.tFontSize }
                fontFamily={ 'sans-serif' }
                key={`key-${guid()}`}
                textAnchor={ 'start' }
                x={ this.x }
                y={ this.y }
            >
                <textPath href={`#${this.id}`}>
                    {this.textContent}
                </textPath>
            </text>
        );
    }
}
